@if(linkEnabled) {
<span class="cursor-pointer items-center font-sans text-sm font-medium no-underline hover:text-link-hover sm:text-xs" [class.text-link]="!isReportControl"
      [class.truncate]="!enableListMultiline"
      [style.overflow-wrap]="enableListMultiline ? 'anywhere' : null"
      [style.text-wrap]="enableListMultiline ? 'pretty' : null"
      (click)="titleAction($event)">
        {{ value }}
</span>
}@else{
<span class="items-center font-sans text-sm font-medium no-underline sm:text-xs"
      [class.truncate]="!enableListMultiline"
      [style.overflow-wrap]="enableListMultiline ? 'anywhere' : null"
      [style.text-wrap]="enableListMultiline ? 'pretty' : null">
        {{ value }}
</span>
}